import { Container, Title, Text, Code } from "@mantine/core";
import { useRouteError } from "react-router";

export const ErrorElement = () => {
  const error = useRouteError();

  return (
    <Container my="lg">
      <Title mb="xl">Ein Fehler ist aufgetreten</Title>

      {error instanceof Error ? (
        <>
          <Text mb="xl">
            Bitte nehmen Sie Kontakt mit der Volksbank PLUS auf und teilen Sie
            die folgenden Informationen mit:
          </Text>

          <Code block>{error.stack}</Code>
        </>
      ) : (
        <Text>
          Bitte laden Sie die Seite neu und führen Sie die Aktion erneut aus.
        </Text>
      )}
    </Container>
  );
};
